const timerangedata = [
    {
        "value": 315,
        "day": "2018-08-04"
    },
    {
        "value": 67,
        "day": "2018-05-30"
    },
    {
        "value": 311,
        "day": "2018-04-19"
    },
    {
        "value": 46,
        "day": "2018-05-14"
    },
    {
        "value": 395,
        "day": "2018-06-07"
    },
    {
        "value": 147,
        "day": "2018-06-02"
    },
    {
        "value": 65,
        "day": "2018-04-03"
    },
    {
        "value": 104,
        "day": "2018-04-22"
    },
    {
        "value": 187,
        "day": "2018-07-23"
    },
    {
        "value": 81,
        "day": "2018-04-26"
    },
    {
        "value": 160,
        "day": "2018-04-29"
    },
    {
        "value": 64,
        "day": "2018-06-04"
    },
    {
        "value": 25,
        "day": "2018-07-15"
    },
    {
        "value": 258,
        "day": "2018-07-29"
    },
    {
        "value": 76,
        "day": "2018-06-18"
    },
    {
        "value": 66,
        "day": "2018-05-29"
    },
    {
        "value": 134,
        "day": "2018-06-13"
    },
    {
        "value": 8,
        "day": "2018-05-06"
    },
    {
        "value": 199,
        "day": "2018-06-25"
    },
    {
        "value": 274,
        "day": "2018-06-01"
    },
    {
        "value": 308,
        "day": "2018-05-23"
    },
    {
        "value": 182,
        "day": "2018-06-19"
    },
    {
        "value": 162,
        "day": "2018-07-12"
    },
    {
        "value": 205,
        "day": "2018-04-25"
    },
    {
        "value": 127,
        "day": "2018-08-07"
    },
    {
        "value": 272,
        "day": "2018-05-13"
    },
    {
        "value": 302,
        "day": "2018-05-12"
    },
    {
        "value": 177,
        "day": "2018-08-05"
    },
    {
        "value": 68,
        "day": "2018-08-10"
    },
    {
        "value": 391,
        "day": "2018-05-15"
    },
    {
        "value": 127,
        "day": "2018-05-24"
    },
    {
        "value": 285,
        "day": "2018-06-21"
    },
    {
        "value": 44,
        "day": "2018-08-01"
    },
    {
        "value": 347,
        "day": "2018-04-09"
    },
    {
        "value": 113,
        "day": "2018-06-09"
    },
    {
        "value": 199,
        "day": "2018-06-23"
    },
    {
        "value": 178,
        "day": "2018-07-21"
    },
    {
        "value": 326,
        "day": "2018-05-02"
    },
    {
        "value": 87,
        "day": "2018-07-18"
    },
    {
        "value": 277,
        "day": "2018-06-12"
    },
    {
        "value": 324,
        "day": "2018-07-10"
    },
    {
        "value": 21,
        "day": "2018-06-17"
    },
    {
        "value": 215,
        "day": "2018-04-07"
    },
    {
        "value": 79,
        "day": "2018-05-31"
    },
    {
        "value": 284,
        "day": "2018-06-03"
    },
    {
        "value": 82,
        "day": "2018-05-22"
    },
    {
        "value": 163,
        "day": "2018-06-20"
    },
    {
        "value": 304,
        "day": "2018-07-05"
    },
    {
        "value": 381,
        "day": "2018-06-29"
    },
    {
        "value": 329,
        "day": "2018-06-26"
    },
    {
        "value": 319,
        "day": "2018-05-25"
    },
    {
        "value": 63,
        "day": "2018-05-01"
    },
    {
        "value": 298,
        "day": "2018-07-20"
    },
    {
        "value": 85,
        "day": "2018-06-16"
    },
    {
        "value": 390,
        "day": "2018-06-30"
    },
    {
        "value": 290,
        "day": "2018-04-14"
    },
    {
        "value": 233,
        "day": "2018-04-11"
    },
    {
        "value": 0,
        "day": "2018-04-01"
    },
    {
        "value": 254,
        "day": "2018-07-09"
    },
    {
        "value": 274,
        "day": "2018-06-28"
    },
    {
        "value": 285,
        "day": "2018-04-24"
    },
    {
        "value": 390,
        "day": "2018-06-10"
    },
    {
        "value": 180,
        "day": "2018-05-16"
    },
    {
        "value": 1,
        "day": "2018-06-05"
    },
    {
        "value": 303,
        "day": "2018-05-17"
    },
    {
        "value": 192,
        "day": "2018-08-03"
    },
    {
        "value": 271,
        "day": "2018-08-06"
    },
    {
        "value": 278,
        "day": "2018-05-19"
    },
    {
        "value": 108,
        "day": "2018-07-13"
    },
    {
        "value": 333,
        "day": "2018-07-06"
    },
    {
        "value": 74,
        "day": "2018-05-26"
    },
    {
        "value": 377,
        "day": "2018-07-30"
    },
    {
        "value": 260,
        "day": "2018-07-11"
    },
    {
        "value": 229,
        "day": "2018-04-17"
    },
    {
        "value": 67,
        "day": "2018-07-27"
    },
    {
        "value": 376,
        "day": "2018-05-03"
    },
    {
        "value": 28,
        "day": "2018-07-01"
    },
    {
        "value": 309,
        "day": "2018-05-04"
    },
    {
        "value": 128,
        "day": "2018-08-09"
    },
    {
        "value": 181,
        "day": "2018-04-28"
    },
    {
        "value": 144,
        "day": "2018-05-27"
    },
    {
        "value": 321,
        "day": "2018-07-14"
    },
    {
        "value": 360,
        "day": "2018-05-11"
    },
    {
        "value": 43,
        "day": "2018-06-08"
    },
    {
        "value": 163,
        "day": "2018-07-25"
    },
    {
        "value": 229,
        "day": "2018-04-12"
    },
    {
        "value": 277,
        "day": "2018-05-20"
    },
    {
        "value": 229,
        "day": "2018-08-11"
    },
    {
        "value": 159,
        "day": "2018-04-08"
    },
    {
        "value": 124,
        "day": "2018-08-02"
    },
    {
        "value": 184,
        "day": "2018-04-13"
    },
    {
        "value": 31,
        "day": "2018-05-28"
    },
    {
        "value": 302,
        "day": "2018-05-10"
    },
    {
        "value": 292,
        "day": "2018-07-19"
    },
    {
        "value": 102,
        "day": "2018-07-02"
    },
    {
        "value": 70,
        "day": "2018-07-24"
    },
    {
        "value": 146,
        "day": "2018-04-27"
    },
    {
        "value": 113,
        "day": "2018-07-17"
    },
    {
        "value": 240,
        "day": "2018-04-06"
    },
    {
        "value": 155,
        "day": "2018-07-03"
    },
    {
        "value": 154,
        "day": "2018-04-18"
    },
    {
        "value": 118,
        "day": "2018-07-16"
    },
    {
        "value": 305,
        "day": "2018-06-11"
    },
    {
        "value": 307,
        "day": "2018-06-14"
    },
    {
        "value": 51,
        "day": "2018-04-20"
    },
    {
        "value": 25,
        "day": "2018-08-08"
    },
    {
        "value": 268,
        "day": "2018-07-07"
    },
    {
        "value": 228,
        "day": "2018-04-02"
    },
    {
        "value": 285,
        "day": "2018-04-30"
    },
    {
        "value": 233,
        "day": "2018-06-24"
    },
    {
        "value": 32,
        "day": "2018-05-09"
    },
    {
        "value": 274,
        "day": "2018-05-08"
    },
    {
        "value": 308,
        "day": "2018-07-26"
    },
    {
        "value": 337,
        "day": "2018-04-23"
    },
    {
        "value": 16,
        "day": "2018-05-07"
    },
    {
        "value": 290,
        "day": "2018-04-16"
    },
    {
        "value": 381,
        "day": "2018-07-08"
    },
    {
        "value": 282,
        "day": "2018-04-10"
    },
    {
        "value": 93,
        "day": "2018-06-22"
    },
    {
        "value": 204,
        "day": "2018-06-15"
    }
]
export default timerangedata;